import React from 'react';

import {
  Box,
  Button,
  styled
} from '@mui/material';
import {
  BaseModal, fields, Form
} from 'iron-forge-react-modules';

import { DateTime } from 'luxon';
import { useForm } from 'react-hook-form';
import * as dataService from './dataService';
import _ from 'lodash';



const FormContentBox = styled(Box)(({ theme }) => ({
  padding: theme.spacing(2)
}));

const ControlledDateField = fields.DateField.genControllerComponent<IFormState>();
const ControlledTextField = fields.TextField.genControllerComponent<IFormState>();


interface IFormState {
  startDate: Date | null;
  orderId: string;
}

export interface IProps {
  storeId: string;

  onClose: (didQuery: boolean) => void;
}

export const FC: React.FC<IProps> = props => {
  const [
    cacheAndProcessOrders,
    cacheAndProcessOrdersTuple
  ] = dataService.useCacheAndProcessOrders(props.storeId ?? '');



  const form = useForm<IFormState>({
    defaultValues: {
      startDate: null, //DateTime.now().minus({ weeks: 1 }).startOf('day').toJSDate(),
      orderId: ''
    }
  });



  const processSubmit = React.useCallback(
    async (formState: IFormState) => {
      if (_.isNil(formState.startDate) && _.isEmpty(formState.orderId)) {
        window.alert("Either start date or order ID must be provided.");
        return;
      }
      let startTime: DateTime | null = null;
      if (!_.isNil(formState.startDate)) {
        startTime = DateTime.fromJSDate(formState.startDate);
        const startOfDay = startTime.startOf('day');
        const now = DateTime.now();

        if (now.diff(startOfDay).as('seconds') < 0) {
          window.alert("Time must be before the current time.");
          return;
        }
      }
      await cacheAndProcessOrders(startTime, formState.orderId);
      props.onClose(true);
    },
    [
      cacheAndProcessOrders,
      props
    ]
  );



  const loading = cacheAndProcessOrdersTuple.loading;

  const fnChildren = React.useCallback(
    () => (
      <Form.FC onSubmit={form.handleSubmit(processSubmit)}>
        <FormContentBox>
          <ControlledDateField
            isRequired={false}
            isDisabled={loading}
            fieldKey="startDate"
            formControl={form.control}
            label="Start Date"
          />

          <ControlledTextField
            isRequired={false}
            isDisabled={loading}
            fieldKey="orderId"
            formControl={form.control}
            label="Order ID"
          />
          <Button type="submit">
            Submit
          </Button>
        </FormContentBox>
      </Form.FC>
    ),
    [
      form,
      loading,
      processSubmit
    ]
  );

  return (
    <BaseModal.FC isOpen>
      {fnChildren}
    </BaseModal.FC>
  );
};
